module.exports = __webpack_public_path__ + "media/description-exit.0b523604.mp3";